// removed by extract-text-webpack-plugin
module.exports = {"fullscreenButton":"fullscreen-button-module__fullscreenButton___zcZNx","fullscreenIcon":"fullscreen-button-module__fullscreenIcon___35GLt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fullscreen-button/fullscreen-button.module.scss
// module id = 1311
// module chunks = 0